import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class PythonCellRunModel extends ModeModelBase {
  override _name = 'pythonCellRun';
  override belongsTo = 'pythonCell';
  override parentIdAttribute = 'token';
  override idAttribute = 'token';
  override hasMany = [{ name: 'pythonCellRunResults' }];
  override attributes = [{ name: 'executionCount', default: null }];
}

@Injectable({ providedIn: 'root' })
export class PythonCellRunModelAccessor extends ModelAccessorBase<PythonCellRunModel> {
  override name = 'pythonCellRun';
  override idAttribute = 'token';
  override parentModel = 'pythonCell';
  override parentIdAttribute = 'token';
  override getIdFromLink = (link) => {
    return link.split('/runs/')[1];
  };
  createModel(resource, opts?) {
    const model = new PythonCellRunModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.pythonCellRun');
  }
}
